import { Tooltip } from '@material-ui/core';
import { MenuItemsEnum } from 'enums/menuItemsEnum';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { QuickActionMenuItemIcon, QuickActionMenuItemStyled } from './QuickActionMenu.styled';

interface IProps {
  currentMenuItem?: MenuItemsEnum;
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
  label: string;
  requiredMenuItems?: Array<MenuItemsEnum>;
  iconComponent?: React.ReactNode;
  disabled?: boolean;
  displayTooltip?: boolean;
  tooltipMessageCode?: string;
}

const QuickActionMenuItem = ({
  currentMenuItem,
  handleClick,
  label,
  requiredMenuItems,
  iconComponent,
  disabled,
  displayTooltip,
  tooltipMessageCode,
}: IProps): JSX.Element => {
  const matchMenuOptions = (): boolean => {
    if (requiredMenuItems && currentMenuItem) {
      return requiredMenuItems.includes(currentMenuItem);
    }
    return true;
  };

  const { t } = useTranslation();

  return displayTooltip && tooltipMessageCode ? (
    <Tooltip title={<>{t(tooltipMessageCode)}</>}>
      <div>
        {matchMenuOptions() &&
          (iconComponent ? (
            <QuickActionMenuItemIcon onClick={handleClick} disabled={disabled}>
              {iconComponent}
              {t(label)}
            </QuickActionMenuItemIcon>
          ) : (
            <QuickActionMenuItemStyled onClick={handleClick} disabled={disabled}>
              {t(label)}
            </QuickActionMenuItemStyled>
          ))}
      </div>
    </Tooltip>
  ) : (
    <Fragment>
      {matchMenuOptions() &&
        (iconComponent ? (
          <QuickActionMenuItemIcon onClick={handleClick} disabled={disabled}>
            {iconComponent}
            {t(label)}
          </QuickActionMenuItemIcon>
        ) : (
          <QuickActionMenuItemStyled onClick={handleClick} disabled={disabled}>
            {t(label)}
          </QuickActionMenuItemStyled>
        ))}
    </Fragment>
  );
};

export default QuickActionMenuItem;
